const listenToButtonClick = (buttenText, onClicked) => {
  const observer = new MutationObserver(() => {
    const button = Array.from(document.querySelectorAll('button')).find(
      (btn) => btn.textContent === buttenText
    )

    if (button) button.addEventListener('click', onClicked)
  })

  observer.observe(document.querySelector('body'), {
    childList: true,
    subtree: true,
  })
}
